import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiService } from '../api.service';
import { AzureAuthService } from '../auth/AuthAzureService';
import { AuthTokenService } from '../auth-token.service';
import { StorageService } from '../storage/storage.service';
import { Employee, SyncUser } from '../../interfaces/users.interface';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  USER_PROFILE_KEY = 'user_profile';

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private authAzureService: AzureAuthService,
    private authTokenService: AuthTokenService,
    private storageService: StorageService
  ) {}

  init() {
    const profile: any = this.storageService.getItem(this.USER_PROFILE_KEY);
    if (profile) {
      const token = profile['token'];
      if (token) {
        this.authTokenService.setToken({ access_token: token });
      }
    }
  }

  getTokenSubject() {
    return this.authTokenService.getTokenSubject();
  }

  logout(): Observable<any> {
    this.authTokenService.setToken(null);
    this.storageService.setItem(this.USER_PROFILE_KEY, null);
    this.storageService.clear();
    return this.authAzureService.logout().pipe(
      tap(() => {
        //  console.log('Session closed successfully');
      })
    );
  }

  getEmployees(): Observable<Employee[]> {
    return this.apiService.buildAPIGet<Employee[]>('/users/employees/');
  }

  getEmployeeByExternalId(externalId: string): Observable<Employee> {
    return this.apiService.buildAPIGet<Employee>(
      `/users/employees/${externalId}/`
    );
  }

  syncUsers(): Observable<SyncUser[]> {
    const data = {
      sync: true,
    };
    return this.apiService.buildAPIPost<SyncUser[]>(
      '/users/serveto/sync/',
      data as any
    );
  }

  getHealth(): Observable<any> {
    return this.apiService.buildAPIGet<any>('/monitoring/health');
  }

  getThreads(): Observable<any> {
    return this.apiService.buildAPIGet<any>('/monitoring/threads/active');
  }
}
